import { jsx as _jsx } from "react/jsx-runtime";
import { useFeatureFlags } from '../../infra/feature-flags';
import { UserSettings } from './user-settings';
export var UserSettingsContainer = function () {
    var _a = useFeatureFlags(), showTwoFaSettings = _a["2FaEnable"], showLanguageSettings = _a.multiLanguageUserSettings;
    return _jsx(UserSettings, { showTwoFaSettings: showTwoFaSettings, showLanguageSettings: showLanguageSettings });
};
